import React, { useState } from 'react';
import { SearchIcon, FilterIcon, SortAscIcon, XIcon } from 'lucide-react';
interface FilterBarProps {
  onSearch: (term: string) => void;
  selectedTags: string[];
  onTagSelect: (tag: string) => void;
  availableTags: string[];
}
export const FilterBar: React.FC<FilterBarProps> = ({
  onSearch,
  selectedTags,
  onTagSelect,
  availableTags
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showMobileTags, setShowMobileTags] = useState(false);
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const term = e.target.value;
    setSearchTerm(term);
    onSearch(term);
  };
  const handleClearSearch = () => {
    setSearchTerm('');
    onSearch('');
  };
  return <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-4 w-full" data-id="element-413">
      <div className="flex flex-col space-y-4" data-id="element-414">
        {/* Search bar */}
        <div className="relative flex-grow w-full" data-id="element-415">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-416">
            <SearchIcon size={18} className="text-gray-400" data-id="element-417" />
          </div>
          <input type="text" placeholder="Search people..." value={searchTerm} className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm" onChange={handleSearchChange} data-id="element-418" />
          {searchTerm && <button className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={handleClearSearch} data-id="element-419">
              <XIcon size={16} className="text-gray-400 hover:text-gray-600" data-id="element-420" />
            </button>}
        </div>
        {/* Tags - Desktop */}
        <div className="hidden md:flex md:flex-wrap md:items-center" data-id="element-421">
          <span className="text-sm text-gray-500 mr-2" data-id="element-422">Filter by:</span>
          <div className="flex flex-wrap gap-2" data-id="element-423">
            {availableTags.map(tag => <button key={tag} onClick={() => onTagSelect(tag)} className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${selectedTags.includes(tag) ? 'bg-[#f9b30f] text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-424">
                {tag}
              </button>)}
          </div>
        </div>
        {/* Mobile tags toggle */}
        <div className="md:hidden flex justify-between items-center" data-id="element-425">
          <button onClick={() => setShowMobileTags(!showMobileTags)} className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-426">
            <FilterIcon size={14} className="mr-1" data-id="element-427" />
            {selectedTags.length > 0 ? `Filters (${selectedTags.length})` : 'Filters'}
          </button>
          <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-428">
            <SortAscIcon size={14} className="mr-1" data-id="element-429" />
            Sort
          </button>
        </div>
        {/* Mobile tags dropdown */}
        {showMobileTags && <div className="md:hidden mt-2 p-3 bg-gray-50 rounded-md border border-gray-200" data-id="element-430">
            <div className="flex justify-between items-center mb-2" data-id="element-431">
              <h4 className="text-sm font-medium text-gray-700" data-id="element-432">
                Filter by tag
              </h4>
              <button onClick={() => setShowMobileTags(false)} className="text-gray-400 hover:text-gray-600" data-id="element-433">
                <XIcon size={16} data-id="element-434" />
              </button>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-435">
              {availableTags.map(tag => <button key={tag} onClick={() => onTagSelect(tag)} className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${selectedTags.includes(tag) ? 'bg-[#f9b30f] text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-436">
                  {tag}
                </button>)}
            </div>
          </div>}
      </div>
    </div>;
};